import React from "react";

import { InfoIcon as Info } from "@packages/ds";
import { useIntl } from "react-intl";

import { Button, IconControl } from "ds/Button";
import Dialog from "ds/Dialog";

import IntervalNumInput from "../IntervalNumInput";

import * as S from "./MaxManualBackupsInput.styles";

type MaxManualBackupsInputProps = {
  value: number | null;
  manualBackupOnChange: (value: number) => void;
};
const MaxManualBackupsInput = ({
  value,
  manualBackupOnChange
}: MaxManualBackupsInputProps) => {
  const intl = useIntl();

  return (
    <>
      <S.MaxManualBackupLabelWrapper>
        <S.LabelInput htmlFor="max_manual_backups">
          {intl.formatMessage({
            id: "backup_schedule.max_manual_backups.label",
            defaultMessage: "Maximum manual backups"
          })}
        </S.LabelInput>
        <Dialog
          align="center"
          title={intl.formatMessage({
            id: "backup_schedule.max_manual_backups.tooltip.title",
            defaultMessage: "Maximum manual backups"
          })}
          description={intl.formatMessage({
            id: "backup_schedule.max_manual_backups.tooltip.description",
            defaultMessage:
              "Set the number manual backups that can be stored before new manual backups will overwrite the oldest."
          })}
          link={
            <Button
              variant="link"
              href={intl.formatMessage({
                id: "links.documentation.environments.backup.manual_backups"
              })}
              analyticId="learnmore"
            >
              {intl.formatMessage({ id: "learnmore" })}
            </Button>
          }
          trigger={
            <IconControl>
              <Info />
            </IconControl>
          }
        />
      </S.MaxManualBackupLabelWrapper>
      <IntervalNumInput
        id="max_manual_backups"
        value={value ?? ""}
        onBlur={manualBackupOnChange}
        onChange={manualBackupOnChange}
        isValid={true}
        width="80px"
      />
    </>
  );
};

export default MaxManualBackupsInput;
